import { IFormatObjectEditable } from "../../editableFormat";
import { AbstractFormatAlert } from "../../editableFormat/alerts";

export class QuestionnaireObjectAlert extends AbstractFormatAlert {
  constructor(object: IFormatObjectEditable, target: string, description: string) {
    super(true);
    this._detectedObject = object.clone();
    this._description = description;
    this._target = target;
  }

  protected readonly _detectedObject: IFormatObjectEditable;
  protected readonly _description: string;
  protected readonly _target: string;

  get detectedObject(): IFormatObjectEditable {
    return this._detectedObject;
  }

  get kind(): string {
    return "オブジェクト属性警告";
  }

  get target(): string {
    return this._target;
  }

  get description(): string {
    return this._description;
  }
}
